<!-- <div class="card-detail-view-area" *ngIf="(tickets$ | async)?.length > 0">
    <div class="card-list-table__travel-card-title">
        <h2 >{{'TRAVEL_TICKETS_ON_EMAIL' | translate}}</h2>
    </div>
    <div class="card-list-table__travel-card"></div>

    <div class="card-detail-view-area-ticket">

        <rwidget-account-tickets-list [tickets]="(tickets$ | async)" (requestTicketAction)="ticketAction($event)"
            [locale]="locale"></rwidget-account-tickets-list>
    </div>
</div> -->
<section [attr.aria-busy]="!(accountTicketsLoaded$ | async)" aria-live="polite">
    <div
        class="empty-card-detail-view-area-ticket"
        *ngIf="
            (selectedRelatedCard$ | async) &&
            !(selectedRelatedCard$ | async).blocked &&
            (tickets$ | async) &&
            (tickets$ | async).length === 0 &&
            (accountTicketsLoaded$ | async)
        ">
        <p class="empty-card-detail-view-area-ticket__title">{{ 'NO_TICKETS_YET' | translate }}</p>
        <p class="empty-card-detail-view-area-ticket__description">{{ 'BUY_PERIOD_TICKET_CARD' | translate }}</p>
        <button class="btn btn--primary" *ngIf="isWebPurchaseAllowed" (click)="navigate()">
            {{ 'BUY_PERIOD_TICKET' | translate }}
        </button>
    </div>

    <div class="card-detail-view-area-ticket" *ngIf="(accountTicketsLoaded$ | async) && (tickets$ | async)?.length > 0">
        <p class="title text-bold">{{ 'MY_TICKETS_ON_CARD' | translate }}</p>
        <rwidget-account-tickets-list
            [tickets]="tickets$ | async"
            [actions]="ticketActions"
            [useInputActions]="useInputActions"
            [locale]="selectedLanguageCode"
            (requestTicketAction)="ticketAction($event)">
        </rwidget-account-tickets-list>
    </div>
</section>

<ridango-ui-basic-loading-spinner
    *ngIf="!(accountTicketsLoaded$ | async)"
    [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate"></ridango-ui-basic-loading-spinner>
